export default __webpack_public_path__ + "staticlp3/media/galileu.a2412e51.jpg";